/*
 *  -----------------------------------------------------------------------
 *    <copyright file="add-crf-dialog.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { SVTRule } from '@components/admin/add-rules/rules-row/rules-row.interface';
import { RuleClauseEnumType, RuleClauseOperatorEnumType } from 'types/graphql-global-types';
import { StudyCrfFields_StudyCrf_crfRules_Rule as StudyCrfFields_crfRules } from '@queries/generated/fragments.generated';

export const ADD_CRF_INITIAL_STATE = {
    id: null,
    subjectCode: '',
    crfName: '',
    required: true,
    active: true,
    configId: null,
};
export const ADD_CRF_INITIAL_ERRORS = { subjectCode: '', crfName: '', configId: '' };

const ADD_CRF_DEFAULT_RULES = [
    {
        key: 'rule-1',
        field: 'default',
        operator: RuleClauseOperatorEnumType.IS_NULL,
        value: '',
        andOr: RuleClauseEnumType.NONE,
        isValid: true,
        index: 0,
    },
    {
        key: 'rule-2',
        field: 'default',
        operator: RuleClauseOperatorEnumType.IS_NULL,
        value: '',
        andOr: RuleClauseEnumType.NONE,
        isValid: true,
        index: 1,
    },
];

export const getInitialRules = (crfRules: (StudyCrfFields_crfRules | null)[] | null | undefined) => {
    let rules: SVTRule[];
    if (crfRules?.length) {
        rules = crfRules.map((rule, index) => ({
            key: `rule-${index}`,
            field: rule?.comparatorField,
            operator: rule?.ruleClauseOperator,
            value: rule?.value,
            andOr: rule?.ruleClause,
            isValid: true,
            index,
        })) as SVTRule[];
    } else {
        rules = ADD_CRF_DEFAULT_RULES.map((rule) => ({ ...rule }));
    }

    if (crfRules?.length === 1) {
        rules.push({ ...ADD_CRF_DEFAULT_RULES[1] });
    }
    return rules;
};
